import { createContext } from 'react';
import { LanguageContextType } from '../types/LanguageContextType';

const LanguageContext = createContext<LanguageContextType>({
  language: 'fr-FR',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  changeLanguage: () => {},
});

export default LanguageContext;
